import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var WeddingRingsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M6.5 1h2.6c.117 0 .2.034.269.063.048.02.09.037.131.037l.8.8c.2.2.2.5 0 .7l-.984 1.124C12.557 4.343 15.1 7.2 15.1 10.7c0 1.43-.478 2.707-1.143 3.815a1 1 0 01-1.715-1.03c.536-.892.858-1.815.858-2.785 0-2.837-2.342-5.1-5.1-5.1-2.737 0-5.008 2.245-5.1 5.015.008 2.494 1.936 4.663 4.337 4.994a1 1 0 11-.274 1.982C3.57 17.122.9 14.1.9 10.6v-.03C1 7.282 3.327 4.493 6.43 3.778L5.4 2.6c-.2-.2-.2-.5 0-.7l.8-.8c.05 0 .1-.025.15-.05.05-.025.1-.05.15-.05z"
                        }),
                        _jsx("path", {
                            d: "M15.505 7.8a1 1 0 011.094-.895c3.51.35 6.301 3.38 6.301 6.995a7.06 7.06 0 01-7.1 7.1 7.06 7.06 0 01-7.1-7.1c0-1.191.355-2.336.786-3.306a1 1 0 011.828.812c-.369.83-.614 1.685-.614 2.494a5.06 5.06 0 005.1 5.1 5.06 5.06 0 005.1-5.1c0-2.584-2.009-4.756-4.5-5.005a1 1 0 01-.895-1.095z"
                        })
                    ]
                })
            })
        ]
    });
};
WeddingRingsIcon.isCarinaIcon = true;
export default WeddingRingsIcon;
